import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropDownOption, ValueChangeEvent } from '@app/core/interfaces/common/form.interface';
import { UniverseItem } from '@app/core/interfaces/model/universe.interface';
import { UniverseService } from '@app/core/services/common/universe.service';
import { debounceTime, distinctUntilChanged, take } from 'rxjs';

@Component({
  selector: 'app-search-symbol',
  templateUrl: './search-symbol.component.html',
  styleUrls: ['./search-symbol.component.scss'],
})
export class SearchSymbolComponent implements OnInit {
  @Input() value: any = null;
  @Input() disabled = false;
  @Input() label = 'Symbol';
  @Input() searchOnly = false;
  @Output() selectOption = new EventEmitter<UniverseItem>();
  @Output() cleartOption = new EventEmitter<any>();


  @Input() symbolOptions: DropDownOption[] = [];
  // debounceTimeout;
  searchExpanded = false;
 symbolSelected: UniverseItem = {
    ricsIdentifier: '',
  };

  constructor(private universeSrv: UniverseService) { }

  ngOnInit() {}

  onSearch(queryData: ValueChangeEvent) {
    if (queryData.value && queryData.value.length >= 3 && (!this.symbolSelected || queryData.value !== this.symbolSelected.ricsIdentifier)) {
      this.universeSrv.searchSymbols(queryData.value).pipe(
      ).subscribe({
        next: res => { if (res && res.length) {
          this.symbolOptions = res;
          this.searchExpanded = true;
        } else {
          this.symbolOptions = [];
          this.searchExpanded = false;
        }},
        error: err => console.log(err)
      });
    }else {
      this.symbolOptions = [];
      this.searchExpanded = false;

      if (queryData.value === '') {
        this.cleartOption.emit();
      }
    }
  }

  optionSelected({ value, option }: { value: UniverseItem; option: DropDownOption }) {
    this.symbolSelected = value;
    this.selectOption.emit(value);
    this.searchExpanded = false;
  }


}
